import { Component, Input, Output, EventEmitter, OnInit, ViewChildren, QueryList, ViewChild, ViewContainerRef, ElementRef, AfterViewInit, ChangeDetectorRef, ViewRef, Renderer2, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model/lifestyle.model';
import { UntypedFormGroup } from '@angular/forms';
import { AccordionQuestionsDirective } from '../accord-content-directive';
import { AccordionCtlTypeEmitterModel } from './accord.model';
import { Tooltip } from 'src/app/model/tooltip';
import { SyncService } from 'src/app/pages/medical-underwriting/services/sync.service';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { QuestionsToAPI } from 'src/app/pages/medical-underwriting/model/lifestyle.post.model';
import { AlertModal } from 'src/app/model/alert';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { UtilService } from 'src/app/shared/services/api-services/util.service';


@Component({
  selector: 'accord',
  templateUrl: `./accord.component.html`,
  styleUrls: [`./accord.component.scss`]
})
export class AccordComponent implements OnInit, AfterViewInit {
  public accordianData;
  @ViewChild('accordionToRemove', { static: true }) accordionToRemove;
  @Input() accordionQuesObj: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  @Input() accordIndexToAppend: number;
  @Input() editMode: boolean;
  tooltipObj: any;
  @Output() deleteEvent = new EventEmitter();
  @Output() openEvent = new EventEmitter();
  @Output() accordionEmitter = new EventEmitter();
  @Output() addAccordionEmitter = new EventEmitter();
  @Output() deleteAccordionEmitter = new EventEmitter();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  accordionTittle: string = "Heart condition";
  private questionModels: QuestionsToAPI[];
  private numberOfAccordFromSavedData: number;
  private prefix: string;
  public showError: boolean = false;
  isDelete: boolean = false;
  contentData: any;
  showDeleteBtnFlag: boolean;
  public heartModalConfig: AlertModal;
  subscription: Subscription;

  @ViewChildren(AccordionQuestionsDirective) accordList: QueryList<AccordionQuestionsDirective>;

  constructor(private cdRef: ChangeDetectorRef, private renderer2: Renderer2, public el: ElementRef,
    private syncService: SyncService, private activatedRoute: ActivatedRoute,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private utilService: UtilService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.heartMC;
  }

  ngOnInit() {
    this.accordIndexToAppend = (this.accordIndexToAppend) ? this.accordIndexToAppend : 0; // initially accordIndex will be undefined, so we set it as zero
    this.prefix = this.utilityServiceForMedicalService.getAccordionWithoutQuesIdPrefix(this.accordIndexToAppend);
    this.syncService.addAccordIndexToPrepareBackEndJson(this.accordIndexToAppend);
    this.tooltipObj = this.initializeToolTipAccordion(this.accordionQuesObj);
    this.initAccordObj();
    this.showDeleteBtn();
    let temp = this.utilityServiceForMedicalService.getAnswerFromStore(this.accordionQuesObj.id);
    this.questionModels = temp ? temp.questionModels : null;
    if (this.questionModels && this.questionModels.length > 0) {
      this.numberOfAccordFromSavedData = this.utilityServiceForMedicalService.getNumberOfSameIndexInstance(this.questionModels);
    }
    this.heartModalConfig = this.contentData.modalHeartConfig;
    this.subscription = this.utilService.updateEditForm.subscribe(res => {
      if (res) {
        this.editMode = false;
      }
      if (res && res.value && res.value.id && res.action &&
        (this.accordionQuesObj.id === res.value.id) && (this.accordIndexToAppend === res.extraParam)) {
        if (res.action === "add-accordion") {
          this.addAnotherAccordionFunToProceed();
        }
        if (res.action === "delete-accordion") {
          this.deleteMedicationFunToProceed();
        }
      }
    });
  }

  ngAfterViewInit() {
    let elementRefComp: ViewContainerRef;
    this.accordList.forEach((element) => {
      elementRefComp = element.viewContainerRef;
    });
    if (this.numberOfAccordFromSavedData) {
      let accordionModelObj = new AccordionCtlTypeEmitterModel(elementRefComp, this.accordIndexToAppend, true);
      this.accordionEmitter.emit(accordionModelObj);
      let nextAccordInd = (this.accordIndexToAppend + 1);
      if (nextAccordInd < this.numberOfAccordFromSavedData) {
        setTimeout(() => {
          this.setAccordBtnObj(nextAccordInd);
          this.addAccordionEmitter.emit(nextAccordInd);
          this.showDeleteBtnEvt();
          this.AddBtnDisableDispatchEvt();
        }, 200);
      }
    }
    else {
      let accordionModelObj = new AccordionCtlTypeEmitterModel(elementRefComp, this.accordIndexToAppend, false);
      this.accordionEmitter.emit(accordionModelObj);
    }
    if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
      this.cdRef.detectChanges();
    }
  }

  showDeleteBtn(): void {
    this.showDeleteBtnFlag = true;
    let temp = this.syncService.getAccordionBtnObj();
    if (temp && temp.numberOfAccord === 1) {
      this.showDeleteBtnFlag = false;
    }
  }

  setAccordBtnObj(newIndex: number) {
    let temp = this.syncService.getAccordionBtnObj();
    if (temp) {
      temp.numberOfAccord = (temp.numberOfAccord + 1);
      temp.maxNumberOfAccord = temp.maxNumberOfAccord;
      temp.lastIndexCreated = newIndex;
      this.syncService.setAccordionBtnObj(temp);
    }
  }

  addAnotherAccordion() {
    if (this.editMode) {
      this.closedDeleteModal();
      const payload = {
        value: this.accordionQuesObj,
        action: "add-accordion",
        extraParam: this.accordIndexToAppend
      };
      this.editModelHandler.emit(payload);
    } else {
      this.addAnotherAccordionFunToProceed();
    }
  }

  addAnotherAccordionFunToProceed(){
    this.accordianData.selected = false;
    let newIndex = this.accordIndexToAppend + 1;
    this.setAccordBtnObj(newIndex); // adding 1 because index starts from zero and add existing accordion 
    this.addAccordionEmitter.emit(newIndex);
    this.showDeleteBtnEvt();
    this.AddBtnDisableDispatchEvt();
  }

  initAccordObj() {
    let expandFlag = (this.accordIndexToAppend === 0) ? true: false;
    this.accordianData = {
      id: 0,
      header: 'header',
      selected: expandFlag
    };
  }

  initializeToolTipAccordion(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  delete() {
    this.isDelete = true;
  }

  hide() {
    this.accordianData.selected = !this.accordianData.selected;
  }
  closedDeleteModal() {
    this.isDelete = false;
  }
  deleteMedication() {
    if (this.editMode) {
      this.closedDeleteModal();
      const payload = {
        value: this.accordionQuesObj,
        action: "delete-accordion",
        extraParam: this.accordIndexToAppend
      };
      this.editModelHandler.emit(payload);
    } else {
      this.deleteMedicationFunToProceed();
    }

  }

  deleteMedicationFunToProceed() {
    this.closedDeleteModal();
    let temp = this.syncService.getAccordionBtnObj();
    if (temp && temp.numberOfAccord > 1) {
      temp.numberOfAccord = (temp.numberOfAccord - 1);
      temp.maxNumberOfAccord = temp.maxNumberOfAccord;
      this.syncService.setAccordionBtnObj(temp);
    }
    this.renderer2.removeChild(this.el.nativeElement, this.accordionToRemove.nativeElement);
    this.syncService.removeAccordIndexToPrepareBackEndJson(this.accordIndexToAppend);
    this.deleteAccordionEmitter.emit(this.accordIndexToAppend);
    this.showDeleteBtn();
    this.showDeleteBtnEvt();
    this.AddBtnDisableDispatchEvt();
  }

  showDeleteBtnEvt() { // this event to trigger for all the accordions to show/hide delete btn
    let showDeleteBtnEvt = new CustomEvent("showDeleteBtnEvt", null);
    document.dispatchEvent(showDeleteBtnEvt);
  }

  AddBtnDisableDispatchEvt() {
    let AddBtnDisableEvt = new CustomEvent("AddBtnDisableEvt", null);
    document.dispatchEvent(AddBtnDisableEvt);
  }

  cancel() {
    this.isDelete = false;
  }

  resetErrorFunCallBack() {
    let resetErrorFun;
    if (resetErrorFun) {
      clearTimeout(resetErrorFun);
    }
    if (!resetErrorFun) {
      resetErrorFun = setTimeout(function () {
        this.showError = false;
        if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
        }
      }.bind(this), 3000);
    }
  }

  @HostListener('document:accordionValidationEvt', ['$event'])
  showAccordionErrorMsg(event) {
    this.showError = false;
    if (event && event.detail && Array.isArray(event.detail)) {
      let temp = this.prefix.split('-');

      event.detail.forEach(element => {
        if (temp && temp[0] && temp[0].includes(element)) {
          this.showError = true;
          this.accordianData.selected = true;
        }
      });
    }
    if (this.showError) {
      this.resetErrorFunCallBack();
    }
  }

  @HostListener('document:clearAccordionErrorMsgEvt', ['$event'])
  clearErrorMes(event) {
    this.showError = false;
  }

  @HostListener('document:addAccordionEvent', ['$event'])
  addAccordionEventListener(event) {
    this.accordianData.selected = false;
    let temp = this.syncService.getAccordionBtnObj();
    if (temp && temp.lastIndexCreated === this.accordIndexToAppend &&
      (temp.maxNumberOfAccord > temp.numberOfAccord)) {
      this.addAnotherAccordion();
    }

  }

  @HostListener('document:showDeleteBtnEvt', ['$event'])
  showDeleteBtnEvtEventListener(event) {
    this.showDeleteBtn();
  }

  @HostListener('document:accordionTittleEvent', ['$event'])
  handleAccordionTittleEvent(event) {
    if (event && event.detail && event.detail.tittle && (this.accordIndexToAppend === event.detail.index)) {
      this.accordionTittle = 'Heart condition - ' + event.detail.tittle;
    }
  }

  displayMobileTooltipReceiver(){
    this.onDisplayMobileTooltipEmitter.emit();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}